import axiosInstance from 'src/utils/axios'

export type PaymentType = 'money' | 'credit' | 'debit' | 'pix' | 'card'

export type PaymentSlot = {
  gross: number
  tax: number
  net: number
  count: number
}

export type PaymentMap = Record<PaymentType, PaymentSlot>

export type FechamentoSeller = {
  sellerId: string
  sellerName: string
  sellerEmail?: string
  gross: number
  tax: number
  net: number
  orderCount: number
  firstSale: string | null
  lastSale: string | null
  payments: PaymentMap
}

export type FechamentoProduct = {
  productName: string
  categoryName: string
  totalQuantity: number
  totalRevenue: number
  payments: PaymentMap
}

export type FechamentoEvent = {
  _id: string
  name: string
  date?: string
  local?: string
  address?: string
  document?: string
}

export type FechamentoData = {
  event: FechamentoEvent | null
  taxConfig: Record<string, number> | null
  period: { start: string | null; end: string | null }
  totals: {
    gross: number
    tax: number
    net: number
    orderCount: number
    sellerCount: number
    averageTicket: number
  }
  paymentTotals: PaymentMap
  sellers: FechamentoSeller[]
  products: FechamentoProduct[]
}

export type FechamentoParams = {
  event: string
  startDate?: Date | null
  endDate?: Date | null
}

export const PAYMENT_TYPE_ORDER: PaymentType[] = ['money', 'credit', 'debit', 'pix', 'card']

export const PAYMENT_TYPE_LABELS: Record<PaymentType, string> = {
  money: 'Dinheiro',
  credit: 'Crédito',
  debit: 'Débito',
  pix: 'Pix',
  card: 'CashLess',
}

export async function fetchFechamento(params: FechamentoParams): Promise<FechamentoData> {
  const { event, startDate, endDate } = params

  const res = await axiosInstance.get('/dashboard/fechamento', {
    params: {
      event,
      startDate: startDate ? startDate.toISOString() : undefined,
      endDate: endDate ? endDate.toISOString() : undefined,
    },
  })

  return res.data
}
